const login = () => import(/* webpackPrefetch: true */ '@/views/public/index.vue')
const register = () => import(/* webpackPrefetch: true */ '@/views/public/registrasi.vue')
const register_informasi_usaha = () => import(/* webpackPrefetch: true */ '@/views/public/registrasi/informasi-usaha/_id.vue')
const register_jenis_usaha = () => import(/* webpackPrefetch: true */ '@/views/public/registrasi/jenis-usaha/_id.vue')
const register_informasi_user = () => import(/* webpackPrefetch: true */ '@/views/public/registrasi/informasi-user/index.vue')
const verification = () => import(/* webpackPrefetch: true */ '@/views/public/verifikasi-phone/_id.vue')
const verification_email = () => import(/* webpackPrefetch: true */ '@/views/public/verifikasi-email/_id.vue')
const terverifikasi = () => import(/* webpackPrefetch: true */ '@/views/public/terverifikasi/index.vue')

const routes = [
  {
    path: "/login",
    name: "Admin Login",
    component: login,
    meta: {
      title: "Admin Login"
    }
  },
  {
    path: "/register",
    name: "register",
    component: register,
    meta: {
      title: "Registrasi Member"
    },
    children: [
      {
        path: "/register/informasi-usaha/:id",
        name: "register informasi usaha",
        component: register_informasi_usaha,
        meta: {
          title: "Registrasi Member"
        }
      },
      {
        path: "/register/jenis-usaha/:id",
        name: "register jenis usaha",
        component: register_jenis_usaha,
        meta: {
          title: "Registrasi Member"
        }
      },
      {
        path: "/register/informasi-user",
        name: "register informasi user",
        component: register_informasi_user,
        meta: {
          title: "Registrasi Member"
        }
      }
    ]
  },
  {
    path: "/verification-phone/:id",
    name: "verification",
    component: verification,
    meta: {
      title: "Verifikasi Akun"
    }
  }, 

  {
    path: "/verification-email/:id",
    name: "verification email",
    component: verification_email,
    meta: {
      title: "Verifikasi Akun"
    }
  
  },
  {
    path: "/berhasil-terverifikasi",
    name: "berhasil-terverifikasi",
    component: terverifikasi,
    meta: {
      title: "Berhasil Terverifikasi"
    }
  
  }
]
export default routes.map(route => {
  const meta = {
    all: false, 
    public: true,
    onlyLoggedOut: true,
    title: route.meta.title
  }
  return { ...route, meta }
})